// extracted by mini-css-extract-plugin
export default {"selectBox":"FaqListPage_selectBox__DqtbX"};